import { render, staticRenderFns } from "./SubGallery.vue?vue&type=template&id=8fbc0cb4&"
import script from "./SubGallery.vue?vue&type=script&lang=js&"
export * from "./SubGallery.vue?vue&type=script&lang=js&"
import style0 from "./SubGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports